import { useEffect, useState } from "react";
import { fetchSession, type SessionInfo } from "../api/session";
import { extractApiErrorMessage } from "../api/client";

interface UseSessionResult {
    session: SessionInfo | null;
    error: string | null;
    ready: boolean;
}

/**
 * Bootstraps the guest identity on mount by calling GET /session. The
 * backend creates the guest (and sets the HttpOnly cookie) on first visit,
 * or confirms the existing one on every later visit/reload - this hook
 * never reads or stores the identity itself, it only reflects what the
 * server confirmed.
 */
export function useSession(): UseSessionResult {
    const [session, setSession] = useState<SessionInfo | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        fetchSession()
            .then((info) => {
                if (!cancelled) setSession(info);
            })
            .catch((err: unknown) => {
                if (!cancelled) {
                    setError(extractApiErrorMessage(err, "Impossibile avviare la sessione."));
                }
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return { session, error, ready: session !== null };
}
